import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isLocalDataBackedMailboxInfo } from 'owa-account-source-list/lib/utils/isLocalDataBackedAccount';
import { isPstFileMutationEnabled } from 'owa-account-source-list/lib/flights';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';

/**
 * Whether or not the mailbox supports modifications, e.g. creating, updating, or deleting things.
 * If this is disabled, the mailbox should be treated as read-only.
 *
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 */
export const mailboxModificationCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        // If the mailbox supports modifications, they're always allowed
        return true;
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        return (
            !mailboxInfo /*allowed by default*/ ||
            ((isPstFileMutationEnabled() ||
                !isLocalDataBackedMailboxInfo(
                    mailboxInfo
                )) /* only disallowed for local data backed mailboxes (e.g. PST files) */ &&
                !isUnifiedInboxMailboxInfo(
                    mailboxInfo
                )) /* Unified Inbox is read-only for now - Until we have read V0 done, then we will work on V1 - Write support and remove this check */
        );
    },
};
